import React from 'react';
import { Dropdown } from './StyledDropdown';
import { PlanResponse } from '@/api/tax-guide';

type PlanListProps = {
  plan?: PlanResponse;
  planList: Array<PlanResponse>;
  setPlan: (plan: PlanResponse) => void;
  enabled?: boolean;
};

export const PlanDropdown = (props: PlanListProps) => {
  const { plan, planList, setPlan, enabled } = props;
  if (!enabled) return <></>;
  return (
    <>
      <Dropdown
        label="Plan"
        id={plan?.id ?? ''}
        options={planList || []}
        handleChange={selectedPlan => {
          const setSelectedPlan = planList?.filter(
            plan => plan.id === selectedPlan,
          )?.[0];
          setPlan(setSelectedPlan);
        }}
        defaultText={'Select Plan'}
      />
    </>
  );
};
